export default "__VITE_ASSET__CG1Uz6YJ__"